import { EventSource } from 'eventsource';
import { addSseMessage } from 'feature/sseEventManager/sseEventSlice';
import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'store/store';
import { acquireAccessToken } from './axios';

export const SSE_EVENT_TYPE = {
	CLAIM: 'CLAIM',
	MEMBER: 'MEMBER',
};

export const useSse = (providerId?: string) => {
	const dispatch = useDispatch<AppDispatch>();
	const [connectionAttempt, setConnectionAttempt] = useState(0);
	const [connected, setConnected] = useState(false);

	const eventSource = useRef<EventSource | null>(null);

	useEffect(() => {
		if (connected) return;
		if (connectionAttempt >= 5) return; //if 5 or more tries fails let's stop

		if (!providerId) return;
		if (eventSource.current) eventSource.current.close(); // close connection if i was listening an other provider

		const es = new EventSource(
			`${process.env.REACT_APP_API_URL}/notifications/${providerId}`,
			{
				fetch: async (input, init) =>
					fetch(input, {
						...init,
						headers: {
							...init?.headers,
							Authorization: await acquireAccessToken(),
							'Mercurio-Client-Type': 'provider-portal',
						},
					}),
			},
		);
		eventSource.current = es;

		es.addEventListener('error', err => {
			setConnected(false);
			setTimeout(() => {
				setConnectionAttempt(prev => prev + 1);
			}, 10000);
			console.log(`sse error. reconnect attempt: ${connectionAttempt}`);
			es.close();
		});

		es.addEventListener('notification', ev => {
			const oEvent = JSON.parse(ev.data);
			dispatch(
				addSseMessage({
					type: oEvent.type,
					key: oEvent.data.key,
					value: oEvent.data.value,
				}),
			);

			if (!connected) setConnected(true);
			if (connectionAttempt !== 0) setConnectionAttempt(0);
		});
	}, [connectionAttempt, providerId, dispatch, connected]);
};
